import axios from "axios";
import baseURL from "../../../utils/baseURL";
import {
  resetErrAction,
  resetSuccessAction,
} from "../globalActions/globalActions";
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

//initalsState
const initialState = {
  styles: [],
  style: {},
  loading: false,
  error: null,
  isAdded: false,
  isUpdated: false,
  isDelete: false,
};

//create style action
export const createStyleAction = createAsyncThunk(
  "style/create",
  async (name, { rejectWithValue, getState, dispatch }) => {
    try {
      //Token - Authenticated
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      
      const { data } = await axios.post(
        `${baseURL}/styles`,
        name,
        config
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//fetch styles action
export const fetchStylesAction = createAsyncThunk(
  "styles/fetch-all",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const { data } = await axios.get(`${baseURL}/styles`);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
//slice
const stylesSlice = createSlice({
  name: "styles",
  initialState,
  extraReducers: (builder) => {
    //create
    builder.addCase(createStyleAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createStyleAction.fulfilled, (state, action) => {
      state.loading = false;
      state.style = action.payload;
      state.isAdded = true;
    });
    builder.addCase(createStyleAction.rejected, (state, action) => {
      state.loading = false;
      state.style = null;
      state.isAdded = false;
      state.error = action.payload;
    });

    //fetch all
    builder.addCase(fetchStylesAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStylesAction.fulfilled, (state, action) => {
      state.loading = false;
      state.styles = action.payload;
      state.isAdded = true;
    });
    builder.addCase(fetchStylesAction.rejected, (state, action) => {
      state.loading = false;
      state.styles = null;
      state.isAdded = false;
      state.error = action.payload;
    });
    //reset error action
    builder.addCase(resetErrAction.pending, (state, action) => {
      state.isAdded = false;
      state.error = null;
    });
    //reset success action
    builder.addCase(resetSuccessAction.pending, (state, action) => {
      state.isAdded = false;
      state.error = null;
    });
  },
});

//generate the reducer
const StylesReducer = stylesSlice.reducer;

export default StylesReducer;